'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                  * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                  * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                  */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkComponent = function LinkComponent() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var children = props.children,
        href = props.href,
        className = props.className;


    return _react2.default.createElement(
        'a',
        _extends({
            role: props['role'],
            'data-toggle': props['data-toggle'],
            'data-haspopup': props['data-haspopup'],
            'aria-expanded': props['aria-expanded'],
            href: href,
            className: className
        }, (0, _index.getSupportEventMap)(props)),
        children
    );
};

exports.default = LinkComponent;